const SLIDE_TRANSITION_DURATION = 1500;

export {
    SLIDE_TRANSITION_DURATION,
};
